import type { MessageDescriptor } from "@lingui/core";

import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { ApiConnector } from "../../../api/api-connector";
import { Select } from "../../../components/ui-kit/fields/select";
import { CountsAnalytics } from "./counts-analytics";
import { QuestionnaireAnalytics } from "./questionnaire-analytics";

export const AnalyticsRoute = observer(function AnalyticsRoute(props: {
  api: ApiConnector;
}) {
  const [type, setType] = useState("events");

  return (
    <div>
      <label>
        <Trans>Analytics type:</Trans>{" "}
        <Select values={analyticsType} value={type} onChange={setType} />
      </label>
      <br className="h-5" />

      {type === "questionnaires" ? (
        <QuestionnaireAnalytics api={props.api} />
      ) : (
        <CountsAnalytics type={type} api={props.api} />
      )}
    </div>
  );
});

const analyticsType: Record<string, MessageDescriptor> = {
  computed: msg`SQ-computed`,
  ppg: msg`PPG`,
  events: msg`Events`,
  audit: msg`Audit items`,
  alerts: msg`Alerts`,
  questionnaires: msg`Questionnaires`,
};
